import { FC, Fragment, useCallback } from "react"
import { useNavigate } from "react-router-dom"

import If from "../../if"
import LoanProgramCardHeader from "./header"
import LoanProgramCardBody from "./body"
import { useFetchPricingSetDetailsQuery } from "../../../../redux/queries"

interface LoanProgramCardProps {
  id: string
  isDefault?: boolean
}

const LoanProgramCard: FC<LoanProgramCardProps> = ({ id, isDefault }) => {
  const navigate = useNavigate()
  const { data: pricingSet, isLoading } = useFetchPricingSetDetailsQuery(
    { id },
    { refetchOnMountOrArgChange: true }
  )

  const handleClick = useCallback(
    (id: string) => {
      navigate(`/loan-programs/${id}`)
    },
    [navigate]
  )

  return (
    <li className="col-span-1 flex flex-col bg-white min-h-[284px]">
      <If
        isLoading={isLoading}
        condition={!isLoading}
        then={
          <Fragment>
            <LoanProgramCardHeader
              pricingSet={pricingSet}
              onClick={handleClick}
            />
            <LoanProgramCardBody
              pricingSet={pricingSet}
              isDefault={isDefault}
            />
          </Fragment>
        }
      />
    </li>
  )
}

export default LoanProgramCard
